// extracted by mini-css-extract-plugin
module.exports = {"ldSpinner":"SpinLoader_ldSpinner__SFaW7","skeleton-loading":"SpinLoader_skeleton-loading__vwBvE"};